export default __webpack_public_path__ + "static/media/flag-burundi.497839e2.svg";